import { TalentWelcomeQuery_applylist } from "__generated__/TalentWelcomeQuery"

export const shouldUseFallbackVersion = (
    applylist: TalentWelcomeQuery_applylist
) => {
    const minCandidates = 4
    return applylist.group!.shortFeaturedCandidates.length < minCandidates
}
